'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.controller('ForgotAccountCtrl', function($window, $location, recoveryService, ErrorResponseHandler) {

  var self = this;

  var errorResponseHandler = new ErrorResponseHandler().registerErrorMessages({
    '400': 'forgot.account.error.server.invalid'
  });

  this.touchDevice = Modernizr.touch;
  this.showThankYouDialog = false;

  this.submitForgotAccount = function(payload) {
    this.pleaseWaitMessage = true;

    if (payload) {
      this.email = payload.email;
      this.dob = payload.dob;
    }

    recoveryService.forgotAccount(this.email, this.dob).then(function() {
      self.alertState = '';
      self.alertMessageKey = '';
      self.showThankYouDialog = true;
      window.dispatchEvent(new CustomEvent('submit-response'));
    }, function(response) {
      self.alertState = 'error';
      self.alertMessageKey = errorResponseHandler.parseErrorResponse(response);
      window.dispatchEvent(new CustomEvent('submit-response',
        {'detail': errorResponseHandler.parseErrorResponse(response)}));
    }).finally(function() {
      self.pleaseWaitMessage = false;
    });
  };

  this.validateModel = function() {
    //check client validation
    if (this.hasClientValidationError()) {
      this.alertState = 'error';
      this.alertMessageKey = 'forgot.account.error.client';
      return;
    }
    if (this.alertMessageKey === 'forgot.account.error.client') {
      this.alertState = '';
      this.alertMessageKey = '';
    }
  };

  this.validateOnClientErrorOnly = function() {
    if (this.alertMessageKey === 'forgot.account.error.client') {
      this.validateModel(false);
    }
  };

  this.goBack = function() {
    $window.history.back();
  };

  this.hasClientValidationError = function() {
    var emailIsNotPresent = this.myForm.email.$dirty && this.myForm.email.$error.required;
    var dobIsNotPresent = this.myForm.dob.$dirty && this.myForm.dob.$error.required;
    var emailisInvalid = this.myForm.email.$invalid;
    var dobIsInvalid = this.myForm.dob.$dirty && this.myForm.dob.$error.validDate;

    return !!(emailIsNotPresent || dobIsNotPresent || emailisInvalid || dobIsInvalid);
  };

  this.submitIsDisabled = function() {
    var emailIsInvalid = this.myForm.email.$dirty && this.myForm.email.$invalid;
    var dobIsInvalid = this.myForm.dob.$dirty && this.myForm.dob.$invalid;
    // Use of !! coerces the value to boolean
    return !!(this.pleaseWaitMessage || this.myForm.email.$pristine || this.myForm.dob.$pristine || emailIsInvalid ||
    dobIsInvalid);
  };

  //DMWS-1072, To prevent event handler accumulates,delete existing 'validLogin' handler then add new
  $(document.documentElement).off('validForgotAccountSubmission');
  $(document.documentElement).on('validForgotAccountSubmission', event => {
    this.submitForgotAccount(event.detail);
  });

});
